<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="bg-white w-full rounded-lg shadow pb-20">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex w-full">
         <button
                        :class="$colors.primary"
                        class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
                        @click="RouterBack()"
                    >
                        <i class="material-icons">chevron_left</i>
                    </button>

          <div class="text-xl font-bold text-blue-600">Payement details</div>
        </div>
      </div>

      <div id="detailP" ref="DownloadComp" class="p-10">
        <header>
          <div class="row align-items-center">
            <div class="col-sm-7  text-sm-start"> <img id="logo" class="imgg" :src="brandingLogo" title="Shipsen" alt="Shipsen"> <b class="mx-2 font-bold text-lg focus:outline-none font-semibold text-menu text-blue-600 text-blue v-super">{{ brandingTitle }}</b></div>
            <div class="col-sm-5  text-sm-end">
              <h4 class="mb-0 h4">Invoice</h4>
              <p class="mb-0 p">Invoice Number - #{{formData.id}}</p>
            </div>
          </div>
          <hr>
       </header>
        <!-- <div class="flex justify-between">
            <h2 class="text-2xl font-bold mb-6 pb-2 tracking-wider uppercase">Invoice</h2>
              <div class="relative mr-4 inline-block">
                <div class="text-gray-500 dis-none cursor-pointer w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-300 inline-flex items-center justify-center"  @click="printInvoice()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-printer" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                    <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path>
                    <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path>
                    <rect x="7" y="13" width="10" height="8" rx="2"></rect>
                  </svg>				  
                </div>
                <div x-show.transition="showTooltip" class="z-40 shadow-lg text-center w-32 block absolute right-0 top-0 p-2 mt-12 rounded-lg bg-gray-800 text-white text-xs" style="display: none;">
                  Print this invoice!
                </div>
              </div>
        </div> -->
        <div class="flex pr-5 pt-2 pl-5 space-x-3">
         <div class="tab-content">
              <div id="latest-tasks-new" class="tab-pane active">
                 <strong>Invoiced To:</strong>
                  <div class="flex items-center mt-10">
                    
                      <div class="border-l-2 border-blue-600 pl-4">
                          <span  class="font-medium flex p-bb" v-if="this.formData.seller"> Seller : {{ formData.seller.fullName }}</span>
                          <span  class="font-medium flex p-bb" v-if="this.formData.warehouse"> Warehouse : {{formData.warehouse.name}}</span>
                          <span  class="font-medium flex p-bb" v-if="formData.date">Date payement : {{  $moment(formData.date).format('yyyy-MM-DD') }}</span>
                          <span v-if="formData.intervalDate && formData.intervalDate.toDate && formData.intervalDate.fromDate" class="font-medium flex p-bb">Période : {{ '[ '+$moment(formData.intervalDate.fromDate).format('yyyy-MM-DD')+' - '+$moment(formData.intervalDate.toDate).format('yyyy-MM-DD')+' ]' }}</span>
                          <span  class="font-medium flex p-bb"> Payment methode : {{ formData.method }}</span>
                          <span  class="font-medium"> NB orders : {{ formData.count }}</span>
                        </div>
                  </div>
              </div>
          </div>

         
        </div>

        <div class="flex  mt-6 relative">
             <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <div
            class="flex justify-between w-full h-auto p-4 rounded-lg border-gray-100"
          >
              <div class="ml-1 w-full p-2">

                <div class="w-full mt-4">
                  <table v-if="formDataPay.QteByProducts" class="min-w-full leading-normal">
                    <thead>
                      <tr>
                          <th :colspan="8" class="text-center text-gray-600 bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 tracking-wider">Orders</th>   
                      </tr>
                      <tr>
                        <th class="px-5 text-xss  py-3 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Product name </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Quantity products </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Total Sales </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Confermation Fees </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Shippings Fees </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Services Fees </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Payement </th>
                      </tr>
                    </thead>
                    <tbody v-for="(item) in formDataPay.QteByProducts" :key="item._id.product.length > 0 ? item._id.product[0]._id : Date.now().toString(36)">
                      <tr>
                        <td
                          class="px-5 py-2 border-b border-gray-200 text-left  bg-white text-xs"
                        >
                         <span class="justify-center text-xs text-left pr-2 py-1 rounded-full text-gray-700">
                            <span class="font-semibold"
                              >{{ item._id.product.length > 0 ? item._id.product[0].name : 'N/A'}}
                            </span>
                          </span>
                        </td>
                        <td
                          class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                        >
                          <span
                            class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"
                          >
                            <span
                              class="text-gray-800 font-semibold text-xs ml-1"
                            >
                              {{item.sumQte}}
                            </span>              
                          </span>
                        </td>
                         <td
                          class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                        >
                         <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700">
                            <span class="font-semibold"
                              > {{item.sumPrices}}
                            </span>
                          </span>
                        </td>
                        <td class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"><span class="font-semibold">{{ item.SumConfirmationsFees }}</span></span>
                        </td>
                       <td class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"><span class="font-semibold">{{ item.SumShippingsFees.toFixed(2)  }}</span></span>
                        </td>
                         <td
                          class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                        >
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700">
                            <span class="font-semibold"
                              >{{ item.SumServicesFees.toFixed(2) }}
                            </span>
                          </span>
                        </td>
                         <td class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"><span class="font-semibold">{{ item.payment.toFixed(2) }}</span></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody class="bg-white">
                     <td  class="px-5 py-2 border-dashed border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs">
                           <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">Total</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('sumQte') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                         <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{SumamountByKey('sumPrices') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('SumConfirmationsFees') }}</span></span>
                      </td>
                       <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('SumShippingsFees') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('SumServicesFees') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('payment') }}</span></span>
                      </td>
                    </tbody>  
                  </table>
                   <table v-if="formDataPay.OrdersUpsell && formDataPay.OrdersUpsell.length>0" class="min-w-full leading-normal mt-5">
                    <thead>
                      <tr>
                          <th :colspan="8" class="text-center text-gray-600 bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 tracking-wider">Orders Cross selling ({{ formDataPay.OrdersUpsell.length }} orders)</th>   
                      </tr>
                      <tr>
                        <th class="px-5 text-xss  py-3 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Order ID </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Products </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Sales </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Confermation Fees </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Shippings Fees </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Services Fees </th>
                        <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider"> Payement </th>
                      </tr>
                    </thead>
                    <tbody v-for="(item) in formDataPay.OrdersUpsell" :key="item._id">
                      <tr>
                        <td
                          class="px-5 py-2 border-b border-gray-200 text-left  bg-white text-xs"
                        >
                         <span class="justify-center text-xs text-left pr-2 py-1 rounded-full text-gray-700">
                            <span class="font-semibold"
                              >{{$f.getIdbySplit(item.id)}}
                            </span>
                          </span>
                        </td>
                        <td
                          class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                        >
                          <span
                            class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"
                          >
                            <span
                              class="text-gray-800 font-semibold text-xs ml-1"
                            >
                              {{ProductNamesGroup(item.details)}}
                            </span>              
                          </span>
                        </td>
                         <td
                          class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                        >
                         <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700">
                            <span class="font-semibold"
                              > {{item.totalPrice}}
                            </span>
                          </span>
                        </td>
                        <td class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"><span class="font-semibold">{{ item.confirmation_vat || formData.fees.confirmation_vat }}</span></span>
                        </td>
                       <td class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"><span class="font-semibold">{{ item.shipping_vat || formData.fees.shipping_vat }}</span></span>
                        </td>
                         <td
                          class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                        >
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700">
                            <span class="font-semibold"
                              >{{ ((item.totalPrice*formData.vat)/100).toFixed(2) }}
                            </span>
                          </span>
                        </td>
                         <td class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-700"><span class="font-semibold">{{ (item.totalPrice-((item.confirmation_vat || formData.fees.confirmation_vat) + (item.shipping_vat || formData.fees.shipping_vat) + ((item.totalPrice*formData.vat)/100))).toFixed(2) }}</span></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody class="bg-white">
                     <td  class="px-5 py-2 border-dashed border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs">
                           <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">Total</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('Qte','upsel') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                         <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{SumamountByKey('totalPrice','upsel') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('SumConfirmationsFeesUpsell','upsel') }}</span></span>
                      </td>
                       <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('SumShippingsFeesUpsell','upsel') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('SumServicesFeesUpsell','upsel') }}</span></span>
                      </td>
                      <td class="px-5 py-2 border-dashed border-t-2 border-b-2 border-gray-800 text-center  bg-white text-xs">
                          <span class="justify-center text-xs text-center pr-2 py-1 rounded-full text-gray-900"><span class="font-bold">{{ SumamountByKey('paymentUpsell','upsel') }}</span></span>
                      </td>
                    </tbody>  
                  </table>
                     <!-- Expedition -->
                  <table v-if="formData.expeditions && formData.expeditions.length>0" class="min-w-full mt-5">
                      <thead>
                          <tr>
                              <th :colspan="7" class="text-center bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Expeditions</th>   
                          </tr>
                      </thead>
                        <thead>
                          <tr>
                             <th class="px-5 text-xss  py-3 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">ID</th> 
                              <th class="px-5 text-xss  py-3 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider"> WEIGHT (KG)</th> 
                              <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">TRANSPORT MODE</th>  
                              <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">DETAILS</th>   
                              <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">CARRIER</th>   
                              <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">COUNTRY</th> 
                              <th class="px-5 text-xss py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">EXPEDITION FEES</th>     
                          </tr>
                      </thead>
                      <tbody class="bg-white">
                          <tr v-for="(exp,ind) in formData.expeditions" :key="ind">
                              <td  class="px-6  whitespace-no-wrap border-b-2 text-left"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="justify-center text-xs  pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.expeditionsdetail.id.id}}</div></td>
                              <td  class="px-6  whitespace-no-wrap border-b-2 text-left"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="justify-center text-xs  pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.expeditionsdetail.id.weight}}</div></td>
                              <td class="px-6 whitespace-no-wrap border-b-2 text-center"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="justify-center text-xs text-leftt pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.expeditionsdetail.id.transportMode}}</div></td>
                              <td class="px-6 whitespace-no-wrap border-b-2 text-center"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="justify-center text-xs text-lteft pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.expeditionsdetail.id.details.length}} Products</div></td>
                              <td class="px-6 whitespace-no-wrap border-b-2 text-center"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="justify-center text-xs text-letft pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.expeditionsdetail.id.carrier.name}}</div></td>
                              <td class="px-6 whitespace-no-wrap border-b-2 text-center"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="justify-center text-xs text-letft pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.expeditionsdetail.id.country}}</div></td>
                              <td class="px-6 whitespace-no-wrap border-b-2 text-center"><div v-if="exp.expeditionsdetail && exp.expeditionsdetail.id" class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{exp.expeditionsdetail.fees }}</div></td>
                          </tr>
                      </tbody>    
                  </table>
                   <!-- REfunds -->
                        <table v-if="formData.refunds && formData.refunds.length >0" class="min-w-full mt-5">
                            <thead>
                                <tr>
                                    <th :colspan="7" class="text-center text-gray-600 bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300  leading-4 tracking-wider">Refunds</th>   
                                </tr>
                            </thead>
                                <thead>
                                <tr>
                                   
                                    <th class="px-5 text-xss  py-3 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">ID</th> 
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">DATE ACCEPTED</th>  
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">PRODUCTS</th>   
                                    <th class="px-5 text-xss py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">CUSTUMER</th>   
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">REFUND</th>    
                                </tr>
                            </thead>
                            <tbody class="bg-white">
                                <tr v-for="(exp,ind) in formData.refunds" :key="ind">
                                  
                                    <td class="px-5 py-2 border-dashed border-t-2  text-left border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.refundsdetail && exp.refundsdetail.id" class="text-sm leading-5 text-blue-900">{{exp.refundsdetail.id.id}}</div></td>
                                    <td class="px-5 py-2 border-dashed border-t-2 text-center border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.refundsdetail && exp.refundsdetail.id" class="justify-center text-xs  pr-2 py-1 rounded-full text-gray-700 font-semibold">{{$moment(exp.refundsdetail.id.acceptedAt).format('yyyy-MM-DD HH:mm') }}</div></td>
                                    <td class="px-5 py-2 border-dashed border-t-2 text-center border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.refundsdetail && exp.refundsdetail.id" class="justify-center text-xs pr-2 py-1 rounded-full text-gray-700 font-semibold">{{ProductNamesGroup(exp.refundsdetail.id.ObjetDetails.products)}}</div></td>
                                    <td class="px-5 py-2 border-dashed border-t-2 text-center border-b-2 border-gray-800 text-left  bg-white text-xs"><div  class="justify-center text-xs  pr-2 py-1 rounded-full text-gray-700 font-semibold" v-if="exp.refundsdetail && exp.refundsdetail.id && exp.refundsdetail.id.ObjetDetails.customer">{{exp.refundsdetail.id.ObjetDetails.customer.fullName}}</div></td>
                                    <td class="px-5 py-2 border-dashed border-t-2 text-center border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.refundsdetail && exp.refundsdetail.id" class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{exp.refundsdetail.id.ObjetDetails.totalPrice }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div></td>
                                </tr>
                            </tbody>       
                        </table> 
                         <!-- Sourcing -->
                        <table v-if="formData.sourcings && formData.sourcings.length >0" class="min-w-full mt-5">
                            <thead>
                                <tr>
                                    <th :colspan="8" class="text-center text-gray-600 bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300  leading-4 tracking-wider">Sourcings</th>   
                                </tr>
                            </thead>
                                <thead>
                                <tr>
                          
                                    <th class="px-5 text-xss  py-3 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">ID</th> 
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">VALIDATION DATE</th>  
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">DETAILS</th>   
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">PROVIDER</th>   
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">COUNTRY</th> 
                                    <th class="px-5 text-xss  py-3 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-blue-700 capitalize tracking-wider">AMOUNT</th>     
                                </tr>
                            </thead>
                            <tbody class="bg-white">
                                <tr v-for="(exp,ind) in formData.sourcings" :key="ind">
                                    <td class="px-3 py-1 border-dashed text-left border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs"><div class="text-sm leading-5 text-blue-900 " v-if="exp.sourcingsdetail && exp.sourcingsdetail.id ">{{exp.sourcingsdetail.id.id}}</div></td>
                                    <td class="px-3 py-1 border-dashed text-center border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.sourcingsdetail && exp.sourcingsdetail.id " class="justify-center text-xs  pr-2 py-1 rounded-full text-gray-700 font-semibold">{{$moment(exp.sourcingsdetail.id.validationDate).format('yyyy-MM-DD HH:mm')}}</div></td>
                                    <td class="px-3 py-1 border-dashed text-center border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.sourcingsdetail && exp.sourcingsdetail.id " class="justify-center text-xs pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.sourcingsdetail.id.details.length}} Products</div></td>
                                    <td class="px-3 py-1 border-dashed text-center border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.sourcingsdetail && exp.sourcingsdetail.id " class="justify-center text-xs pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.sourcingsdetail.id.provider.name}}</div></td>
                                    <td class="px-3 py-1 border-dashed text-center border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.sourcingsdetail && exp.sourcingsdetail.id " class="justify-center text-xs pr-2 py-1 rounded-full text-gray-700 font-semibold">{{exp.sourcingsdetail.id.country}}</div></td>
                                    <td class="px-3 py-1 border-dashed text-center border-t-2  border-b-2 border-gray-800 text-left  bg-white text-xs"><div v-if="exp.sourcingsdetail && exp.sourcingsdetail.id " class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{QuantityTotalOrPrices('price',exp.sourcingsdetail.id.details)+QuantityTotalOrPrices('price',exp.sourcingsdetail.id.fees) }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div></td>
                                </tr>
                            </tbody>       
                        </table>   

                   <div class="py-2 pt-4 ml-auto w-full sm:w-2/4 width-40 lg:w-2/5">
                      <div class="flex justify-between mb-2">
                        <div class="text-xs text-gray-900 font-semibold  flex-1">Total Fees:</div>
                        <div class="text-right w-40">
                          <div class="text-gray-900  text-xs font-medium">{{ fees }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                        </div>
                      </div>
                      <div v-if="formData.order_fees && formData.order_fees.limit && formData.order_fees.fees" class="flex justify-between mb-2">
                        <div class="text-xs text-gray-900 font-semibold  flex-1">Orders Fees:</div>
                        <div class="text-right w-40">
                          <div class="text-gray-900  text-xs font-medium">{{ formData.order_fees.limit*formData.order_fees.fees }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup> {{'('+formData.order_fees.limit+' Orders)'}}</div>
                        </div>
                      </div>
                      <div class="flex justify-between mb-2" v-if="formData.expeditions && formData.expeditions.length >0">
                        <div class="text-xs text-gray-900  font-semibold flex-1">Expeditions Fees:</div>
                        <div class="text-right w-40">
                          <div class="text-gray-900 text-xs font-medium">{{ expeditions  }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                        </div>
                      </div>
                      <div class="flex justify-between mb-2" v-if="formData.refunds && formData.refunds.length >0">
                        <div class="text-xs text-gray-900  font-semibold flex-1">Refunds Fees:</div>
                        <div class="text-right w-40">
                          <div class="text-gray-900 text-xs font-medium">{{ refunds  }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                        </div>
                      </div>
                      <div class="flex justify-between mb-2" v-if="formData.sourcings && formData.sourcings.length >0">
                        <div class="text-xs text-gray-900  font-semibold flex-1">Sourcings Fees:</div>
                        <div class="text-right w-40">
                          <div class="text-gray-900 text-xs font-medium">{{ sourcings?sourcings.toFixed(2):0 }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                        </div>
                      </div>
                      <div class="flex justify-between mb-2" v-if="formData.subscription_fees!=0">
                        <div class="text-xs text-gray-900 font-semibold flex-1">Subscription Fees:</div>
                        <div class="text-right w-40">
                          <div class="text-gray-900 text-xs font-medium">{{ formData.subscription_fees }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                        </div>
                      </div>
                       <div class="flex justify-between mb-2" v-if="formData.avoir_fees && formData.avoir_fees.length >0">
                          <div class="text-xs text-gray-900  font-semibold flex-1">Avoir Amount:</div>
                          <div class="text-right w-40">
                            <div class="text-gray-900 text-xs font-medium">(+) {{ avoirs?avoirs.toFixed(2):0 }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                          </div>
                      </div>
                      <div class="p-2 bg-gray-200 border-b-1 border-t-1 border-gray-300" :class="paymentNet && Math.sign(paymentNet)==-1?'bg-red-300':''">
                        <div class="flex justify-between items-center">
                          <div class="text-xs text-gray-900 font-semibold  flex-1">Net payement:</div> 
                          <div class="text-right w-40">
                            <div class="text-xl text-gray-900 font-bold">{{ paymentNet?paymentNet.toFixed(2):0 }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
          </div>

          
        </div>

         <div class="p-4">
            <div class="flex items-center text-blue-900 font-medium justify-center">
                Thank you very much for doing business with us.
            </div>
        </div>


      </div>
      <footer class="text-center">
             <div class="btn-group btn-group-sm d-print-none"> <a href="javascript:void(0)" @click="printInvoice()" class="btn btn-light border-yy text-black-50 shadow-none"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M16 18h-8v-1h8v1zm-2 1h-6v1h6v-1zm10-14v13h-4v6h-16v-6h-4v-13h4v-5h16v5h4zm-18 0h12v-3h-12v3zm12 10h-12v7h12v-7zm4-8h-20v9h2v-3h16v3h2v-9zm-1.5 1c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z"/></svg> Print</a> </div>
     </footer>
      <div v-if="currentUser &&  currentUser.type && currentUser.type == 'Admin' || currentUser.type=='Administrateur'" class="flex pr-5 pl-5 mt-6">
          <div class="flex justify-between w-full h-auto p-4 rounded-lg border-gray-100" >
            <div class="flex w-full">
              <div class="ml-1 w-full p-2">
                <!--table shipping historie -->
                   <div-table :config="configList" :data="shippingsHistories"  :idWharhouse="idWharhouse" :currentUser="currentUser" :loading="false" :paginate="paginate"  @paginatation="paginatation"></div-table>
                <!--/ table shipping histories -->
              </div>  
            </div> 
          </div>
        </div>  
    </div>
  </div>
</template>




<script>
import image from "@/assets/shipsen-man.jpg";
import jsPDF from 'jspdf'
import config from './configHistories'
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      configList: config.list,
      shippingsHistories:[],
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
       },
      formData: {
        details: [],
        expeditions:[],
        refunds:[],
        sourcings:[],
        avoir_fees:[]
      },
      fees :0,
      refunds:0,
      sourcings:0,
      expeditions:0,
      paymentNet:0,
      avoirs:0,
      image:image,
      formDataPay:[],
      content: [],
      fullPage: false,
      loading:false,
      headers: [
        "#",
        "ID",
        "CUSTOMER",
        "TOTAL PRICE",
        "Confirmation Fees",
        "Shipping Fees",
        "Total",
      ],
      total:0,
      brandingLogo: null,
      brandingTitle: 'ShipSen',
    };
  },
  watch: {
    'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          this.loadBranding();
      }
  },
  async mounted() {
    this.loadBranding();
    if (this.$route.params.id) {
      this.loading=true;
      this.formData.expeditions=this.formData.refunds=this.formData.sourcings=[]
      const data = await this.$server.get("payments", {id: this.$route.params.id,});
      const dataPayementOrder = await this.$server.search("paymentorders", {payment: this.$route.params.id,type:"orders"});
      console.log('dataPayementOrder payement_____________________',dataPayementOrder.content)
      //console.log('map id-----',dataPayementOrder.content.filter(opt => opt.type==="orders").map(opt => opt.ordersdetail.order))
      console.log('ids orders____________________',dataPayementOrder.content.map(i => i.ordersdetail.order))
      this.formData = data.content;
     
     // let idsOrders = this.formData.details.map(i => i.order._id);
      //let idsOrders = dataPayementOrder.content.filter(opt => opt.type==="orders").map(opt => opt.ordersdetail.order);
      let dataP = await this.$server.getProductsAndQteByIds("orders", {QteByProducts:true,ids:dataPayementOrder.content.map(i => i.ordersdetail.order)});
      const newDate = await this.$server.getProductsAndQteByIds("orders", {OrdersUpsell:true,ids:dataPayementOrder.content.map(i => i.ordersdetail.order)});
      if(newDate.OrdersUpsell) dataP.OrdersUpsell=newDate.OrdersUpsell;
      const newDate1 = await this.$server.getProductsAndQteByIds("orders", {TotalPrices:true,ids:dataPayementOrder.content.map(i => i.ordersdetail.order)});
      if(newDate1.TotalPrices) dataP.TotalPrices=newDate1.TotalPrices;

      console.log('dataP order products_____________________',dataP)
      
      if(dataP.QteByProducts){
        this.getServiceFees(dataP);
        this.formDataPay=dataP;
      } 
      console.log('dataP_____________________',dataP)
      const { content: expeditionsData } = await this.$server.search("paymentorders", {payment: this.$route.params.id,type:"expeditions"});
      this.formData.expeditions=expeditionsData;
      console.log('-----expeditionsData-------')
      const { content: refundsData } = await this.$server.search("paymentorders", {payment: this.$route.params.id,type:"refunds"});
      this.formData.refunds=refundsData;
      console.log('-----refundsData-------')
      const { content: sourcingsData } = await this.$server.search("paymentorders", {payment: this.$route.params.id,type:"sourcings"});
      this.formData.sourcings=sourcingsData;
      console.log('-----sourcingsData-------')
      this.getTotalFees();
      this.loading=false;
      console.log('this.formData.sourcings-----',this.formData.sourcings)
    }
    if(this.currentUser.type && (this.currentUser.type == 'Admin' || this.currentUser.type=='Administrateur')) await this.getShippingHistories();

  },
  methods: {
    loadBranding() {
      if (this.idWharhouse && this.currentUser.role && this.currentUser.role.branding && this.idWharhouse._id) {
        const branding = this.currentUser.role.branding.find(
          b => b.warehouse === this.idWharhouse._id || b.warehouse._id === this.idWharhouse._id || b.country === this.idWharhouse.country
        );
        
        if (branding) {
          this.brandingLogo = branding.logo || null;
          this.brandingTitle = branding.title || 'ShipSen';
        } else {
          this.brandingLogo = this.image;
          this.brandingTitle = 'ShipSen';
        }
      }
    },
    ProductNamesGroup(data){
        let product="";
        for (let i in data) {
            product+=data[i].productName
            if(data.length-1 != i) product+=" ,"; 
        }
        return product;
    },
    printInvoice() {
        // console.log(window.location.pathname.split( '/' ))
            var mywindow = window.open('', 'PRINT', 'height=400,width=600');
            mywindow.document.write('<html lang="en"><head><meta charset="utf-8"><title>INVOICE</title>');
            mywindow.document.write('<style type="text/css">.mb-6 { margin-bottom: 0.7rem; }.items-center{ align-items: center;} .align-items-center{ align-items: center !important; } .text-blue { color: #3182ce; } .row { display: flex; flex-wrap: wrap; } .text-sm-end { text-align: right; } .col-sm-5 { flex: 0 0 auto; width: 41.66666667%; } .text-sm-start { text-align: left; } .mb-sm-0 { margin-bottom: 0; } .mb-0 { margin-bottom: 0; } .mb-3 { margin-bottom: 1rem; } .imgg { vertical-align: inherit; width: 40px; display: inline-block; } .v-super{ vertical-align:super } .col-sm-7 { flex: 0 0 auto; width: 58.33333333%; } .h4 { font-size: 1.5rem; color: #0c2f54; } .p { line-height: 1.9; margin-top: 0; margin-bottom: 1rem; } .text-2xl { font-size: 1.5rem; } .pl-4 { padding-left: 1rem; } .border-l-2 { border-left-width: 2px !important;; border-color: #3182ce !important; } .mt-10{ margin-top: 10px; } .text-xss { font-size: 0.70rem !important; } .border-blue-600 { border-color: #3182ce; } .p-4 { padding: 1rem; } .mt-4 { margin-top: 1rem; } .tracking-wider { letter-spacing: 0.05em; } .text-gray-600 { color: #718096; } .text-left { text-align: left; } .text-blue-700 { color: #114f8f; } .px-6 { padding-left: 1.5rem; padding-right: 1.5rem; } .p-bb{ padding-bottom: 4px; } .py-3 { padding-top: 0.55rem; padding-bottom: 0.55rem; } .leading-4 { line-height: 1rem; } .border-b-2 { border-bottom-width: 2px; border-color: #e2e8f0 !important; } .border-t-2 { border-top-width: 2px; border-color: #e2e8f0 !important; } .border-gray-300 { border-color: #e2e8f0; } .bg-gray-200 { background-color: #edf2f7; } .h-auto { height: auto; } .bg-gray-100 { background-color: #f7fafc; } .border-dashed { border-style: dashed; } .border-gray-800 { border-color: #2d3748; } .text-xs { font-size: 0.55rem; } .font-semibold { font-weight: 600; } .dis-none{ display: none; } .text-gray-700 { color: #262728; } .rounded-full { border-radius: 9999px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-gray-200 { border-color: #8e9193; } tbody { display: table-row-group; vertical-align: middle; border-color: inherit; } tr { display: table-row; vertical-align: inherit; border-color: inherit; } .px-5 { padding-left: 1.10rem; padding-right: 1.10rem; } .width-40{ width: 50% !important; } .mb-3 { margin-bottom: 0.75rem; } sup { top: -0.5em; } .mt-10{ margin-bottom: 10px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-t { border-top-width: 1px; border-color: #e2e8f0 !important; } .text-xl { font-size: 1.25rem; } sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; } .pt-4 { padding-top: 1rem; } .text-m { font-size: 18px; } .w-40 { width: 10rem; } .text-right { text-align: right; } .text-gray-900 { color: #1a202c; } .flex-1 { flex: 1 1 0%; } .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; } .ml-auto { margin-left: auto; } .min-w-full { min-width: 100%; } .mt-5 { margin-top: 1.25rem; } table { display: table; border-collapse: collapse; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border-color: grey; } .p-2 { padding: 0.5rem; } .ml-1 { margin-left: 0.25rem; } .overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');
            mywindow.document.write('</head><body style="margin:5mm;margin-top:0mm">');
            mywindow.document.write(document.getElementById("detailP").innerHTML);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/
            setTimeout(function () {
                mywindow.print();
                mywindow.close();
            }, 500);
            return false;
        
    },
     async getShippingHistories() {
      const filter = {
        payment: this.$route.params.id,
      };
      const res = await this.$server.search("paymentsHistories", filter);
      if (res.content && res.content.results) {
        this.shippingsHistories = res.content.results;
        this.shippingsHistories.total = res.content.total;
        this.shippingsHistories.lastpage = res.content.last_page;
        this.shippingsHistories.per_page = res.content.per_page;
        this.shippingsHistories.currentpage = res.content.current_page;
      } else this.shippingsHistories = [];
    },
    async paginatation(direction){
      var page=0;
      if(direction == "next"){
         page=++this.paginate.currentpage;
      }else{
         page=--this.paginate.currentpage;
      }
       const filters = {
          page: page,
          limit: this.limit,
      };
      this.getShippingHistories(filters);
    },
      QuantityTotalOrPrices(type,data){
                var value=0;
                for (let i in data) {
                    if(type=='qte') value+=data[i].quantity;
                    if(type=='price') value+=data[i].price;
                    else value+=data[i].priceDH;
                    
                }
                return value;
        },
        ProductNamesGroup(data){
            let product="";
            for (let i in data) {
                product+=data[i].productName
                if(data.length-1 != i) product+=" ,"; 
            }
            return product;
        },
    RouterBack: function() {
       this.$router.back();
    },
    getServiceFees(data){

      // For QteByProducts - fees now come per product from backend
      if (data.QteByProducts && data.QteByProducts.length > 0) {

        //  data.QteByProducts.forEach(x => {  
        //     x.SumServicesFees =(x.sumPrices*this.formData.vat)/100;
        //     x.SumConfirmationsFees =(x.sumQte*this.formData.fees.confirmation_vat);
        //     x.SumShippingsFees =(x.sumQte*this.formData.fees.shipping_vat);
        //     x.payment =x.sumPrices-(x.SumServicesFees+x.SumConfirmationsFees+x.SumShippingsFees);
        //   });


          data.QteByProducts.forEach(x => {
              // Fees already come from backend per product
              x.SumServicesFees = x.SumServicesFees || 0;
              x.SumConfirmationsFees = x.SumConfirmationsFees || 0;
              x.SumShippingsFees = x.SumShippingsFees || 0;
              x.payment = x.sumPrices - (x.SumServicesFees + x.SumConfirmationsFees + x.SumShippingsFees);
          });

      }


        if (data.OrdersUpsell && data.OrdersUpsell.length > 0) {

          // data.OrdersUpsell.forEach(x => {  
          //     x.SumServicesFeesUpsell =(x.totalPrice*this.formData.vat)/100;
          //     x.SumConfirmationsFeesUpsell =this.formData.fees.confirmation_vat;
          //     x.SumShippingsFeesUpsell =this.formData.fees.shipping_vat;
          //     x.paymentUpsell =x.totalPrice-(x.SumServicesFeesUpsell+x.SumConfirmationsFeesUpsell+x.SumShippingsFeesUpsell);
          //   });

           data.OrdersUpsell.forEach(x => {
            // Use actual fees from paymentorders (comes from backend)
            x.SumServicesFeesUpsell = x.services_fees ? x.services_fees : (x.totalPrice * this.formData.vat) / 100;
            x.SumConfirmationsFeesUpsell = x.confirmation_vat ? x.confirmation_vat : this.formData.fees.confirmation_vat;
            x.SumShippingsFeesUpsell = x.shipping_vat ? x.shipping_vat : this.formData.fees.shipping_vat;

            x.paymentUpsell = x.totalPrice - (x.SumServicesFeesUpsell + x.SumConfirmationsFeesUpsell + x.SumShippingsFeesUpsell);
        });
    }

    },
    // SumamountByKey(key,upsel=null){
    //   var total = 0;
      
    //   if(upsel){
    //     if(this.formDataPay && this.formDataPay.OrdersUpsell && this.formDataPay.OrdersUpsell.length>0){
    //       this.formDataPay.OrdersUpsell.forEach(item => {total += item[key];});
    //       if(key=="SumServicesFeesUpsell" || key=="paymentUpsell") return total.toFixed(2);
    //       if(key=='Qte') total= this.formDataPay.OrdersUpsell.length;
    //     }
    //   }else{
    //       if(this.formDataPay && this.formDataPay.QteByProducts) this.formDataPay.QteByProducts.forEach(item => {total += item[key];});
    //       if(key=="SumServicesFees" || key=="payment" || key=="sumPrices") return total.toFixed(2);
    //   }
      
    //   return total;
    // },
    SumamountByKey(key, upsel = null) {
        var total = 0;

        if (upsel) {
            if (this.formDataPay && this.formDataPay.OrdersUpsell && this.formDataPay.OrdersUpsell.length > 0) {
                this.formDataPay.OrdersUpsell.forEach(item => {
                    total += parseFloat(item[key]) || 0;
                });
                
                // Keys that need decimal formatting
                if (key === "SumServicesFeesUpsell" || key === "paymentUpsell" || key === "SumShippingsFeesUpsell" || key === "SumConfirmationsFeesUpsell") {
                    return total.toFixed(2);
                }
                if (key === 'Qte') total = this.formDataPay.OrdersUpsell.length;
            }
        } else {
            if (this.formDataPay && this.formDataPay.QteByProducts) {
                this.formDataPay.QteByProducts.forEach(item => {
                    total += parseFloat(item[key]) || 0;
                });
                
                // Keys that need decimal formatting
                if (key === "SumServicesFees" || key === "payment" || key === "sumPrices" || key === "SumShippingsFees" || key === "SumConfirmationsFees") {
                    return total.toFixed(2);
                }
            }
        }

        return total;
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    getTotalFees() {
        // this.fees = 0,this.refunds=0,this.sourcings=0,this.expeditions=0,this.paymentNet=0;this.avoirs=0;
        //   this.fees += parseFloat(this.formData.fees.confirmation_vat)+parseFloat(this.formData.fees.shipping_vat);
        //   this.fees=parseFloat(this.fees)*(parseFloat(this.SumamountByKey('sumQte'))+this.SumamountByKey('Qte','upsel'));
        //   console.log('fees ---------:',this.fees)
        // this.formData.refunds.forEach(x => {  if(x.refundsdetail) this.refunds +=parseFloat(x.refundsdetail.fees);});
        // this.formData.sourcings.forEach(x => {  if(x.sourcingsdetail) this.sourcings +=parseFloat(x.sourcingsdetail.fees);});
        // this.formData.expeditions.forEach(x => {  if(x.expeditionsdetail) this.expeditions +=parseFloat(x.expeditionsdetail.fees);});
        // this.formData.avoir_fees.forEach(x => {  if(x.fees) this.avoirs +=parseFloat(x.fees);});
        // this.fees=parseFloat(this.fees)+parseFloat(this.SumamountByKey('SumServicesFees'))+parseFloat(this.SumamountByKey('SumServicesFeesUpsell','upsel'));
        // this.paymentNet=(parseFloat(this.SumamountByKey('totalPrice','upsel'))+parseFloat(this.SumamountByKey('sumPrices'))+this.avoirs)-(this.fees+this.refunds+this.sourcings+this.expeditions+this.formData.subscription_fees);
        // if(this.formData.order_fees && this.formData.order_fees.limit && this.formData.order_fees.fees) this.paymentNet -=this.formData.order_fees.limit*this.formData.order_fees.fees;

        let totalConfirmationFees = 0;
      let totalShippingFees = 0;
      let totalServicesFees = 0;

      // Sum fees from QteByProducts (per product)
      if (this.formDataPay && this.formDataPay.QteByProducts) {
          this.formDataPay.QteByProducts.forEach(x => {
              totalConfirmationFees += parseFloat(x.SumConfirmationsFees) || 0;
              totalShippingFees += parseFloat(x.SumShippingsFees) || 0;
              totalServicesFees += parseFloat(x.SumServicesFees) || 0;
          });
      }

      // Add upsell fees (sum from each order)
      if (this.formDataPay && this.formDataPay.OrdersUpsell && this.formDataPay.OrdersUpsell.length > 0) {
          this.formDataPay.OrdersUpsell.forEach(x => {
              totalConfirmationFees += parseFloat(x.confirmation_vat || x.SumConfirmationsFeesUpsell) || 0;
              totalShippingFees += parseFloat(x.shipping_vat || x.SumShippingsFeesUpsell) || 0;
              totalServicesFees += parseFloat(x.services_fees || x.SumServicesFeesUpsell) || 0;
          });
      }

      // Total fees
      this.fees = totalConfirmationFees + totalShippingFees + totalServicesFees;

      console.log('fees breakdown:', {
          confirmation: totalConfirmationFees,
          shipping: totalShippingFees,
          services: totalServicesFees,
          total: this.fees
      });

      // Other fees
      this.formData.refunds.forEach(x => {
          if (x.refundsdetail) this.refunds += parseFloat(x.refundsdetail.fees);
      });
      this.formData.sourcings.forEach(x => {
          if (x.sourcingsdetail) this.sourcings += parseFloat(x.sourcingsdetail.fees);
      });
      this.formData.expeditions.forEach(x => {
          if (x.expeditionsdetail) this.expeditions += parseFloat(x.expeditionsdetail.fees);
      });
      this.formData.avoir_fees.forEach(x => {
          if (x.fees) this.avoirs += parseFloat(x.fees);
      });

      // Net payment
      const totalSalesQte = parseFloat(this.SumamountByKey('sumPrices')) || 0;
      const totalSalesUpsell = parseFloat(this.SumamountByKey('totalPrice', 'upsel')) || 0;
      const totalSales = totalSalesQte + totalSalesUpsell;

      this.paymentNet = (totalSales + this.avoirs) - (this.fees + this.refunds + this.sourcings + this.expeditions + this.formData.subscription_fees);

      // Order fees
      if (this.formData.order_fees && this.formData.order_fees.limit && this.formData.order_fees.fees) {
          this.paymentNet -= this.formData.order_fees.limit * this.formData.order_fees.fees;
      }
    },
  },
};
</script>

<style scoped>
footer {
    display: block;
}
#detailP{
   background-color: #fff;
    border: 1px solid #ccc;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    -o-border-radius: 6px;
    border-radius: 6px;
    margin: 15px;
}
svg{
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
}
.btn-group, .btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
}
.btn-group>.btn-group:not(:last-child)>.btn, .btn-group>.btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.btn-group-vertical>.btn, .btn-group>.btn {
    position: relative;
    flex: 1 1 auto;
}
.btn-group-sm>.btn, .btn-sm {
    padding: 0.25rem 2.5rem;
    font-size: .875rem;
    border-radius: 0.2rem;
}
.text-black-50 {
    color: rgba(0,0,0,.5)!important;
}
.border-yy {
   border: 1px solid #dee2e6 !important;
}
.shadow-none {
    box-shadow: none;
}
.btn-light {
    color: #000;
    background-color: #f8f9fa!important;
    border-color: #f8f9fa;
}
.btn {
    display: inline-block;
    font-weight: 700;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.row {
    display: flex;
    flex-wrap: wrap;
}
.mt-10{
  margin-top: 10px;
}
.align-items-center{
  align-items: center;
}
.text-sm-end {
    text-align: right;
}
.col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
}
.text-sm-start {
    text-align: left;
}
.mb-sm-0 {
    margin-bottom: 0;
}
.mb-0 {
    margin-bottom: 0;
}
.mb-3 {
    margin-bottom: 1rem;
}
.imgg {
    vertical-align: inherit;
    width: 40px;
    display: inline-block;
}
.v-super{
  vertical-align:super
}
.col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
}
.h4 {
    font-size: 1.5rem;
    color: #0c2f54;
}
.p {
    line-height: 1.9;
    margin-top: 0;
    margin-bottom: 1rem;
}
.empty-row{
   background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
}
.text-m{
  font-size: 18px;
}
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
